import type {
  CoreCoachComplaintsEscalateParams,
  CoreCoachComplaintsReadParams,
  CoreCoachComplaintsResolveParams,
} from '../types/core/methods';
import type {ComplaintApiModel} from './types';

import {EntityStore} from '../utils/entityStore';

export class ComplaintStore<
  T extends ComplaintApiModel = ComplaintApiModel,
> extends EntityStore<T, CoreCoachComplaintsReadParams> {
  escalate = this._createMethod<CoreCoachComplaintsEscalateParams>({
    method: 'coach.complaints.escalate',
  });
  escalateBatch = this._createBatchMethod<CoreCoachComplaintsEscalateParams>({
    method: 'coach.complaints.escalate',
  });
  resolve = this._createMethod<CoreCoachComplaintsResolveParams>({
    method: 'coach.complaints.resolve',
  });
  resolveBatch = this._createBatchMethod<CoreCoachComplaintsResolveParams>({
    method: 'coach.complaints.resolve',
  });
}

export const complaintStore = new ComplaintStore('complaint', {
  fetch: 'coach.complaints.read',
});
